export class RunCandidateScore {
    constructor(companyId, userId) {
        this.companyId = companyId;
        this.userId = userId;
        this.candidateId;
        this.jobId;
        this.jobMatchId;
        this.rerunType; // "CANDIDATE/CANDIDATE_JOB/REQUISITION/GLOBAL"
        this.candidateType;
    }
}
//# sourceMappingURL=runCandidateScore.js.map